// @ts-nocheck
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import PageLayout from '@components/PageLayout';
import PersonalDetailsForm from '@components/my-profile/personal-details/PersonalDetailsForm';

import * as actions from '@redux-actions/';

import { getPersonalDetails } from '@services/myProfileServices';

import { getLabelFallback } from '@utils/utils';

const PersonalDetails = (): JSX.Element => {
    const personalDetailsBackLabel = getLabelFallback('MY_PROFILE_PERSONAL_DETAILS_BACK_CTA_LABEL');
    const personalDetailsLabel = getLabelFallback('MYPROFILE_PERSONAL_DETAILS_TITLE');

    const dispatch = useDispatch();

    const config = useSelector((state: RootState) => state.common.config);
    const personalDetails = useSelector((state: RootState) => state.myProfile.personalDetails);
    const personalDetailsRequestStatus = useSelector(
        (state: RootState) => state.myProfile.personalDetailsRequestStatus
    );
    const isMobile = useSelector((state: RootState) => state.common.isMobile);

    useEffect(() => {
        dispatch(getPersonalDetails(config.mockRequest, config.storeId));
        return () => {
            dispatch(actions.getPersonalDetailsSuccess(null));
        };
    }, []);

    return (
        <PageLayout
            data_element_id="AccountSummary_Profile"
            hideMenu
            labelMenu={personalDetailsLabel}
            backLabel={personalDetailsBackLabel}
        >
            <div className="personal-details-container">
                {!isMobile && (
                    <div
                        role="region"
                        aria-label="personal details page title"
                        className="primary-title"
                    >
                        {getLabelFallback('MYPROFILE_PERSONAL_DETAILS_TITLE')}
                    </div>
                )}
                {personalDetailsRequestStatus === 'SUCCESS' && (
                    <PersonalDetailsForm personalDetails={personalDetails} />
                )}
            </div>
        </PageLayout>
    );
};

export default PersonalDetails;
